import React, {MouseEventHandler, useEffect, useState} from 'react';
import {Button, Col, Form, Input, Modal, Row, Select, Tag} from 'antd';
import Colors from "../../../../styles/Colors";
import {BiCheck, BiImageAdd, BiPlus, BiReceipt, BiUser, BiX} from "react-icons/bi";
import Rebut from "../../../../model/multilleure/rebuts/Rebut";
import Contacte from "../../../../model/multilleure/gestioinscripcions/Contacte";
import ControlHorari from "../../../../model/root/ControlHorari";

interface IngredientModalProps {
    element: Rebut | undefined;
    visible: boolean;
    onClose:  (rebut: Rebut, guardar : boolean) => void;
    handleSubmit: () => void;
    checkData: () => void;
    options: { label: string; value: string; }[];
    contactes: Contacte[] | undefined;
}

const RebutAlgoritmixModal: React.FC<IngredientModalProps> = ({element, visible, onClose, handleSubmit, checkData, contactes, options}) => {
    const [form] = Form.useForm();
    const [IBAN, setIBAN] = useState("");

    const submit = () => {
        const formData = form.getFieldsValue();
        console.log("Form Data:", formData);
        onClose(formData, true);
    };

    const filterOption = (input: string, option?: { label: string; value: string }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());


    const handleCancel = () => {
        onClose(new Rebut(), false);
    };

    const handleSelectChange = (selectedValue: number) => {
        // Realiza las acciones necesarias con el valor seleccionado
        const selectedContact = contactes?.find(contact => contact.id === selectedValue);
        if (selectedContact) {
            setIBAN(selectedContact.IBAN);
            // Realiza otras acciones según sea necesario
        }
    };


    return (
        <Modal
            title="Editar Rebut"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={submit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={700}
        >
            <Form form={form} initialValues={element}>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Preu" name="preu" required>
                            <Input type="number"/>
                        </Form.Item>
                        <Form.Item label="Pagat" name="pagat" required>
                            <Input type="number"/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Estat" name="estat" required>
                            <Select>
                                <option value={"pendent"}>
                                    <Tag color={"orange"}>
                                        Pendent
                                    </Tag>
                                </option>
                                <option value={"pagat"}>
                                    <Tag color={"green"}>
                                        Pagat
                                    </Tag>
                                </option>
                                <option value={"retornat"}>
                                    <Tag color={"red"}>
                                        Retornat
                                    </Tag>
                                </option>
                                <option value={"anulat"}>
                                    <Tag color={"gray"}>
                                        Anulat
                                    </Tag>
                                </option>
                            </Select>
                        </Form.Item>
                        <Form.Item label="Pagament" name="pagament" required>
                            <Select>
                                <option value={"RD"}>
                                    <Tag color={"green"}>
                                        Domiciliat
                                    </Tag>
                                </option>
                                <option value={"TG"}>
                                    <Tag color={"orange"}>
                                        Targeta
                                    </Tag>
                                </option>
                                <option value={"EF"}>
                                    <Tag color={"red"}>
                                        Efectiu
                                    </Tag>
                                </option>
                                <option value={"TR"}>
                                    <Tag color={"blue"}>
                                        Transferència
                                    </Tag>
                                </option>
                            </Select>
                        </Form.Item>
                        <Form.Item label="Concepte" name="concepte" required>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="Observacions" name="observacions">
                            <Input/>
                        </Form.Item>
                    </Col>
                    <hr />
                    <Col span={12}>
                        <Form.Item label="Pagador" name="pagador" required>
                            <Select
                                showSearch
                                placeholder="Selecciona Pagador"
                                optionFilterProp="children"
                                onChange={() => handleSelectChange}
                                filterOption={filterOption}
                                options={options}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={2}>
                        <Button title={"Crear Rebut"} style={{backgroundColor: Colors.colors.color5}}
                                onClick={() => console.log("test")}><BiPlus/></Button>
                    </Col>
                    <Col span={10}>
                        <Form.Item label="iban" name="iban">
                            <Input value={IBAN}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default RebutAlgoritmixModal;
